export default {
  selectSoporte: [
    {
      text: 'Necesito ayuda con la plataforma',
      value: 'plataforma'
    },
    /*{
      text: 'Necesito ayuda con los productos del restaurante',
      value: 'productos_restaurante'
    },
    {
      text: 'Necesito ayuda con mi pedido',
      value: 'pedido_restaurante'
    },*/
  ]
}